import styled from 'styled-components';

export const ContentWrapper = styled.main`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: 23px;

  @media (width >= 48rem) {
    padding-block: var(--spacing-large);
  }
`;

export const InnerWrapper = styled.div`
  display: flex;
  align-items: stretch;
  flex-direction: column;
  justify-content: flex-start;
  gap: 23px;
  padding-inline: var(--spacing-large);

  @media (width >= 48rem) {
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    padding-block: var(--spacing-large);
  }
`;
